import styled from "styled-components";
import { tablet } from "styles/breakpoints";

interface Props {
  background?: string;
  padding?: string;
}

export const SectionWrapper = styled.div<Props>`
  position: relative;
  display: block;
  padding: ${({ padding }) => padding || "3.5rem 0 0 0"};
  background: ${({ background }) => background || ""};

  @media ${tablet} {
    padding: ${({ padding }) => padding || "2rem 1.5rem 0 1.5rem"};
  }
`;